import React from 'react';
import { AirportKey } from '../../data/airports';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { ButtonBar } from '../ButtonBar';
import { DocumentedAirportProps } from '../../data/documentedAirports';
import { DeckState } from '../../typings';

interface WidgetProps {
  onAirportChange: (newAirport: DocumentedAirportProps) => void;

  airports: DocumentedAirportProps[];
  currentAirportKey: AirportKey;

  deckState: DeckState;

  visible: boolean;
  onToggleWidget: () => void;
}


export class Widget extends React.Component<WidgetProps, unknown> {

  renderArticle() {
    const { onAirportChange, airports, currentAirportKey, onToggleWidget } = this.props;
    const index = airports.findIndex(
      current => current.location.key === currentAirportKey,
    );
    const len = airports.length;

    if (index > -1) {
      const prev = index === 0 ? null : airports[index - 1];
      const next = index + 1 < len ? airports[index + 1] : airports[0];

      const current = airports[index];
      return (
        <article>
          <h1>{current.name}</h1>
          <div className='text'>
            {current.descriptions.map((desc, idx) => {
              return <p key={idx}>{desc}</p>;
            })}
            <ButtonBar onClick={onToggleWidget}>
              {prev && (
                <button className='prevBtn' onClick={() => onAirportChange(prev)}>
                  Back
                </button>
              )}
              {next && (
                <button className='nextBtn' onClick={() => onAirportChange(next)}>
                  To {next.btnLabel}
                </button>
              )}
            </ButtonBar>
          </div>
        </article>
      );
    } else {
      return null;
    }
  }

  render() {
    const { visible, onToggleWidget } = this.props;
    return (
      <ReactCSSTransitionGroup
        transitionName='fade'
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}
      >
        {!visible && (
          <button className='guideBtn' onClick={onToggleWidget}>
            i
          </button>
        )}

        {visible && this.renderArticle()}
      </ReactCSSTransitionGroup>
    );
  }
}
